// // import React from "react";
// // import { getBlogs } from "../../api";
// // import { useQuery } from "@tanstack/react-query";
// // import { Link } from "react-router-dom";
// // import notFound from "../../images/not-found.png";

// // export default function Blogs() {
// //   const { data, isFetching } = useQuery({
// //     queryKey: ["blogs"],
// //     queryFn: () => getBlogs(),
// //     initialData: [],
// //   });
// //   const blogs = data.data;

// //   if(!isFetching && data?.data?.length === 0) {
// //     return (
// //       <div className="flex flex-col min-h-[80vh] items-center justify-center">
// //         <div className="font-bold mx-auto">
// //           <img src={notFound} />
// //         </div>
// //         <div className="h-6"></div>
// //         <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold ">
// //            لا توجد مواضيع في الوقت الحالي 
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="mx-4 lg:w-[90%] lg:mx-auto my-14 ">
// //       <h1 className="text-3xl font-medium mb-6 text-center">أحدث المقالات</h1>
// //       {isFetching ? (
// //         <div
// //           dir="ltr"
// //           className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
// //         >
// //           {[...Array(3).keys()].map((e, i) => (
// //             <div
// //               className={`w-full h-[450px] bg-slate-50 rounded-lg overflow-hidden border-2 animate-pulse`}
// //               style={{ animationDelay: `${200 * i}ms` }}
// //             />
// //           ))}
// //         </div>
// //       ) : (
// //         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-right">
// //           {blogs?.map((e, i) => (
// //             <Link
// //               to={`/home/blogs/${e.id}`}
// //               key={i}
// //               className="w-full h-[450px] bg-slate-50 rounded-lg overflow-hidden border duration-300 ease-in-out transform transition-all group hover:scale-[1.03]"
// //             >
// //               <div className="relative w-full h-[200px]">
// //                 <img
// //                   src={e.image}
// //                   alt={e.title}
// //                   className="object-cover group-hover:scale-110 duration-300 ease-in-out transform transition-all max-h-[200px] w-full"
// //                 />
// //               </div>
// //               <div className="p-3 h-[250px] flex flex-col justify-between">
// //                 <div>
// //                   <p className="text-lg font-semibold tracking-wider line-clamp-2">
// //                     {e.title}
// //                   </p>
// //                   <p className="text-sm my-2 indent-2 text-slate-500 line-clamp-5">
// //                     {e.summary}
// //                   </p>
// //                 </div>
// //                 <div className="flex justify-between items-center">
// //                   <div className="flex gap-[0.5px] text-sm text-slate-500">
// //                     <p>
// //                       {new Date(e.created_at).toLocaleString("en-Us", {
// //                         month: "long",
// //                         year: "numeric",
// //                       })}
// //                     </p>
// //                   </div>
// //                   <button className="bg-primary text-white py-1.5 px-3 rounded-lg">
// //                     رؤية المقالة
// //                   </button>
// //                 </div>
// //               </div>
// //             </Link>
// //           ))}
// //         </div>
// //       )}
// //     </div>
// //   );
// // }
// import React, { useState, useMemo, useEffect } from "react";
// import { getBlogs, logActivity } from "../../api";
// import { useQuery } from "@tanstack/react-query";
// import { Link } from "react-router-dom";
// import notFound from "../../images/not-found.png";

// export default function Blogs() {
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const { data, isFetching } = useQuery({
//     queryKey: ["blogs"],
//     queryFn: () => getBlogs(),
//     initialData: { data: [] },
//   });

//   const blogs = data?.data || [];

//   // Debug: log what we receive
//   console.log("Full API response:", data);
//   console.log("Blogs array:", blogs);
//   console.log("First blog:", blogs[0]);

//   const isAuth = !!localStorage.getItem("token"); // or your existing auth logic

//   useEffect(() => {
//     logActivity("Visit Blog", "Page Visit", null, isAuth);
//   }, []);

//   // Extract unique categories from blogs - more robust approach
//   const categories = useMemo(() => {
//     if (!blogs || blogs.length === 0) return [{ id: "all", name: "جميع المقالات" }];

//     const categoryMap = new Map();

//     blogs.forEach(blog => {
//       // Handle different possible structures
//       const category = blog.category || blog.Category || blog.media_category;
//       if (category && category.id && category.name) {
//         if (!categoryMap.has(category.id)) {
//           categoryMap.set(category.id, {
//             id: category.id.toString(),
//             name: category.name
//           });
//         }
//       }
//     });

//     const uniqueCategories = Array.from(categoryMap.values());
//     console.log("Extracted categories:", uniqueCategories);

//     return [{ id: "all", name: "جميع المقالات" }, ...uniqueCategories];
//   }, [blogs]);

//   // Filter blogs based on selected category - more robust approach
//   const filteredBlogs = useMemo(() => {
//     if (selectedCategory === "all") return blogs;

//     return blogs.filter(blog => {
//       const category = blog.category || blog.Category || blog.media_category;
//       const categoryId = category?.id?.toString();
//       return categoryId === selectedCategory;
//     });
//   }, [blogs, selectedCategory]);

//   console.log("Selected category:", selectedCategory);
//   console.log("Filtered blogs count:", filteredBlogs.length);

//   // Rest of your component remains the same...
//   if (!isFetching && blogs.length === 0) {
//     return (
//       <div className="flex flex-col min-h-[80vh] items-center justify-center">
//         <div className="font-bold mx-auto">
//           <img src={notFound} />
//         </div>
//         <div className="h-6"></div>
//         <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold ">
//           لا توجد مواضيع في الوقت الحالي
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="mx-4 lg:w-[90%] lg:mx-auto my-14">
//       <h1 className="text-3xl font-medium mb-6 text-center">أحدث المقالات</h1>

//       {/* Modern Category Tabs */}
//       {categories.length > 1 && (
//         <div className="flex justify-center mb-8">
//           <div className="bg-gray-100 rounded-2xl p-1.5 flex flex-wrap justify-center gap-1 max-w-4xl mx-auto">
//             {categories.map((category) => (
//               <button
//                 key={category.id}
//                 onClick={() => setSelectedCategory(category.id)}
//                 className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 ease-in-out ${selectedCategory === category.id
//                     ? "bg-white text-primary shadow-lg shadow-primary/20 border border-primary/10"
//                     : "text-gray-600 hover:text-primary hover:bg-white/50"
//                   }`}
//               >
//                 {category.name}
//               </button>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Blog Grid */}
//       {isFetching ? (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {[...Array(3).keys()].map((e, i) => (
//             <div
//               key={i}
//               className="w-full h-[450px] bg-slate-50 rounded-2xl overflow-hidden border animate-pulse"
//               style={{ animationDelay: `${200 * i}ms` }}
//             />
//           ))}
//         </div>
//       ) : (
//         <>
//           {/* Results Count */}
//           <div className="text-center mb-6">
//             <p className="text-gray-600">
//               عرض {filteredBlogs.length} من أصل {blogs.length} مقالة
//             </p>
//           </div>

//           {/* Blog Cards */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-right">
//             {filteredBlogs?.map((blog, i) => {
//               const category = blog.category || blog.Category || blog.media_category;

//               return (
//                 <Link
//                   to={`/home/blogs/${blog.id}`}
//                   key={blog.id}
//                   className="group relative bg-white rounded-2xl overflow-hidden border border-gray-200 hover:border-primary/30 transition-all duration-500 ease-out hover:shadow-2xl hover:shadow-primary/10"
//                 >
//                   {/* Category Badge */}
//                   {category && (
//                     <div className="absolute top-4 left-4 z-10">
//                       <span className="bg-primary/90 text-white px-3 py-1.5 rounded-full text-xs font-medium backdrop-blur-sm">
//                         {category.name}
//                       </span>
//                     </div>
//                   )}

//                   {/* Rest of the card content remains the same */}
//                   <div className="relative w-full h-[200px] overflow-hidden">
//                     <img
//                       src={blog.image}
//                       alt={blog.title}
//                       className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 ease-out"
//                     />
//                     <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                   </div>

//                   <div className="p-5 h-[250px] flex flex-col justify-between">
//                     <div>
//                       <h3 className="text-lg font-bold text-gray-800 line-clamp-2 mb-2 group-hover:text-primary transition-colors duration-300">
//                         {blog.title}
//                       </h3>
//                       <p className="text-sm text-gray-600 line-clamp-4 leading-relaxed">
//                         {blog.summary}
//                       </p>
//                     </div>

//                     <div className="flex justify-between items-center pt-4 border-t border-gray-100">
//                       <div className="text-xs text-gray-500">
//                         <p>
//                           {new Date(blog.created_at).toLocaleString("ar-SA", {
//                             month: "long",
//                             year: "numeric",
//                           })}
//                         </p>
//                       </div>
//                       <button className="bg-primary text-white py-2 px-4 rounded-lg hover:bg-primary/90 transition-colors duration-300 font-medium text-sm">
//                         رؤية المقالة
//                       </button>
//                     </div>
//                   </div>

//                   <div className="absolute inset-0 border-2 border-transparent group-hover:border-primary/20 rounded-2xl transition-all duration-300 pointer-events-none" />
//                 </Link>
//               );
//             })}
//           </div>

//           {/* No Results Message */}
//           {filteredBlogs.length === 0 && blogs.length > 0 && (
//             <div className="text-center py-12">
//               <div className="text-gray-400 text-6xl mb-4">📝</div>
//               <h3 className="text-xl font-bold text-gray-600 mb-2">لا توجد مقالات في هذا التصنيف</h3>
//               <p className="text-gray-500">جرب تصنيفاً آخر أو اطلع على جميع المقالات</p>
//               <button
//                 onClick={() => setSelectedCategory("all")}
//                 className="mt-4 bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors duration-300"
//               >
//                 عرض جميع المقالات
//               </button>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// }
import React, { useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getBlogs, logActivity } from "../../api";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import notFound from "../../images/not-found.png";

export default function Blogs() {
  const { t, i18n } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const { data, isFetching } = useQuery({
    queryKey: ["blogs"],
    queryFn: () => getBlogs(),
    initialData: { data: [] },
  });

  const blogs = data?.data || [];

  const isAuth = !!localStorage.getItem("token");

  useEffect(() => {
    logActivity("Visit Blog", "Page Visit", null, isAuth);
  }, []);

  // Extract unique categories from blogs
  const categories = useMemo(() => {
    if (!blogs || blogs.length === 0) return [{ id: "all", name: t("blogs.allArticles") }];

    const categoryMap = new Map();

    blogs.forEach(blog => {
      const category = blog.category || blog.Category || blog.media_category;
      if (category && category.id && category.name) {
        if (!categoryMap.has(category.id)) {
          categoryMap.set(category.id, {
            id: category.id.toString(),
            name: category.name
          });
        }
      }
    });

    const uniqueCategories = Array.from(categoryMap.values());

    return [{ id: "all", name: t("blogs.allArticles") }, ...uniqueCategories];
  }, [blogs, t]);

  // Filter blogs based on selected category
  const filteredBlogs = useMemo(() => {
    if (selectedCategory === "all") return blogs;

    return blogs.filter(blog => {
      const category = blog.category || blog.Category || blog.media_category;
      const categoryId = category?.id?.toString();
      return categoryId === selectedCategory;
    });
  }, [blogs, selectedCategory]);

  if (!isFetching && blogs.length === 0) {
    return (
      <div className="flex flex-col min-h-[80vh] items-center justify-center">
        <div className="font-bold mx-auto">
          <img src={notFound} alt={t("blogs.notFound")} />
        </div>
        <div className="h-6"></div>
        <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold">
          {t("blogs.noTopics")}
        </div>
      </div>
    );
  }

  return (
    <div className="mx-4 lg:w-[90%] lg:mx-auto my-14">
      <h1 className="text-3xl font-medium mb-6 text-center">{t("blogs.latestArticles")}</h1>

      {/* Modern Category Tabs */}
      {categories.length > 1 && (
        <div className="flex justify-center mb-8">
          <div className="bg-gray-100 rounded-2xl p-1.5 flex flex-wrap justify-center gap-1 max-w-4xl mx-auto">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 ease-in-out ${
                  selectedCategory === category.id
                    ? "bg-white text-primary shadow-lg shadow-primary/20 border border-primary/10"
                    : "text-gray-600 hover:text-primary hover:bg-white/50"
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Blog Grid */}
      {isFetching ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...Array(3).keys()].map((e, i) => (
            <div
              key={i}
              className="w-full h-[450px] bg-slate-50 rounded-2xl overflow-hidden border animate-pulse"
              style={{ animationDelay: `${200 * i}ms` }}
            />
          ))}
        </div>
      ) : (
        <>
          {/* Results Count */}
          <div className="text-center mb-6">
            <p className="text-gray-600">
              {t("blogs.showingResults", { count: filteredBlogs.length, total: blogs.length })}
            </p>
          </div>

          {/* Blog Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-right">
            {filteredBlogs?.map((blog, i) => {
              const category = blog.category || blog.Category || blog.media_category;

              return (
                <Link
                  to={`/home/blogs/${blog.id}`}
                  key={blog.id}
                  className="group relative bg-white rounded-2xl overflow-hidden border border-gray-200 hover:border-primary/30 transition-all duration-500 ease-out hover:shadow-2xl hover:shadow-primary/10"
                >
                  {/* Category Badge */}
                  {category && (
                    <div className="absolute top-4 left-4 z-10">
                      <span className="bg-primary/90 text-white px-3 py-1.5 rounded-full text-xs font-medium backdrop-blur-sm">
                        {category.name}
                      </span>
                    </div>
                  )}

                  <div className="relative w-full h-[200px] overflow-hidden">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 ease-out"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>

                  <div className="p-5 h-[250px] flex flex-col justify-between">
                    <div>
                      <h3 className="text-lg font-bold text-gray-800 line-clamp-2 mb-2 group-hover:text-primary transition-colors duration-300">
                        {blog.title}
                      </h3>
                      <p className="text-sm text-gray-600 line-clamp-4 leading-relaxed">
                        {blog.summary}
                      </p>
                    </div>

                    <div className="flex justify-between items-center pt-4 border-t border-gray-100">
                      <div className="text-xs text-gray-500">
                        <p>
                          {new Date(blog.created_at).toLocaleString(i18n.language === 'ar' ? 'ar-SA' : 'en-US', {
                            month: "long",
                            year: "numeric",
                          })}
                        </p>
                      </div>
                      <button className="bg-primary text-white py-2 px-4 rounded-lg hover:bg-primary/90 transition-colors duration-300 font-medium text-sm">
                        {t("blogs.viewArticle")}
                      </button>
                    </div>
                  </div>

                  <div className="absolute inset-0 border-2 border-transparent group-hover:border-primary/20 rounded-2xl transition-all duration-300 pointer-events-none" />
                </Link>
              );
            })}
          </div>

          {/* No Results Message */}
          {filteredBlogs.length === 0 && blogs.length > 0 && (
            <div className="text-center py-12">
              <div className="text-gray-400 text-6xl mb-4">📝</div>
              <h3 className="text-xl font-bold text-gray-600 mb-2">{t("blogs.noArticlesInCategory")}</h3>
              <p className="text-gray-500">{t("blogs.tryAnotherCategory")}</p>
              <button
                onClick={() => setSelectedCategory("all")}
                className="mt-4 bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary/90 transition-colors duration-300"
              >
                {t("blogs.viewAllArticles")}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}